var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "favorites-setting-items",
      attrs: { id: "favorites_setting_items" }
    },
    [
      _c(
        "div",
        { staticClass: "favorites-setting-items__title" },
        [
          _c("span", { staticClass: "text" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("__favorites.hint_text")) +
                "\n        "
            )
          ]),
          _vm._v(" "),
          _c(
            "v-icon",
            {
              staticClass: "close_24px",
              attrs: { color: "white" },
              on: {
                click: function($event) {
                  return _vm.close_dialog()
                }
              }
            },
            [_vm._v("\n            icon-close\n        ")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { attrs: { id: "favorites_btn_area" } }, [
        _c(
          "div",
          {
            staticClass: "btn_style",
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.delete_favorites()
              }
            }
          },
          [
            _c("v-icon", { staticClass: "icon_style" }, [
              _vm._v("\n                icon-trash-can-regular\n            ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "icon_text_style" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("__favorites.delete_text")) +
                  "\n            "
              )
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "btn_style",
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.update_favorites()
              }
            }
          },
          [
            _c("v-icon", { staticClass: "icon_style" }, [
              _vm._v("\n                icon-arrow-collapse-left\n            ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "icon_text_style" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("__favorites.update_text")) +
                  "\n            "
              )
            ])
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }